"use client";

import { LayoutTemplate, FileCode2, Blocks } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const features = [{
  title: "Liderança Executiva",
  description: "Desenvolvimento de competências estratégicas para líderes que buscam longevidade e impacto real no mercado corporativo.",
  icon: LayoutTemplate
}, {
  title: "Networking Estratégico",
  description: "Conexões de alto nível entre profissionais experientes, fomentando parcerias e oportunidades exclusivas de carreira.",
  icon: FileCode2
}, {
  title: "Longevidade Profissional",
  description: "Orientação especializada para a transição de carreira e manutenção da relevância em um cenário global em constante mudança.",
  icon: Blocks
}];
export default function TransformationTechnologies() {
  return;
}